module.exports = __webpack_public_path__ + "static/cobblestonestamp-39ffd12be96c5f3138f8efe8489cdf3f.jpg";